module.exports = __webpack_public_path__ + "img/2.71a2d446.jpg";